// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__AqslX","container":"styles_container__3us29","title":"styles_title__1W3w6","wrapper":"styles_wrapper__gnVuB","answer":"styles_answer__3Wqo1"};